import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ServiceRotationOption } from '@mark43/cad-api';
import {
    ButtonGroup,
    Flex,
    HStack,
    VStack,
    Box,
    InlineBanner,
    Text,
    DataList,
    DataItem,
} from '@cad-arc';
import { FormTextarea } from '../forms/integrated-form-controls/form-text-area';
import { ServiceRotationFormType } from './types';
import { FormSaveButton } from '../forms/integrated-form-components/form-save-button';

export function RotationDisplay({
    isManualSelection,
    isCommentsRequired,
    serviceProvider,
    onSkip,
    onNoAnswer,
    onDeclined,
}: {
    isManualSelection: boolean;
    isCommentsRequired: boolean;
    serviceProvider: ServiceRotationOption;
    onSkip: (serviceRotationOption: ServiceRotationOption) => void;
    onNoAnswer: (serviceRotationOption: ServiceRotationOption) => void;
    onDeclined: (serviceRotationOption: ServiceRotationOption) => void;
}) {
    const { control } = useFormContext<ServiceRotationFormType>();

    return (
        <Box w="full" pt={2} data-testid="SELECTED_ROTATION_OPTION">
            <Box mb={4}>
                <Text variant="headingXs">
                    {isManualSelection ? 'Manual Selection' : 'Recommended'}
                </Text>
            </Box>
            <Box
                p="4"
                w="full"
                borderRadius="md"
                border="1px solid var(--arc-colors-border-default)"
            >
                <VStack w="full" align="left">
                    <HStack w="full" alignItems="flex-start">
                        <Box flex="1">
                            <DataList variant="stacked">
                                <DataItem dataKey="Name">{serviceProvider.label}</DataItem>
                            </DataList>
                        </Box>
                        <Box flex="1">
                            <DataList variant="stacked">
                                <DataItem dataKey="Phone">{serviceProvider.phoneNumber}</DataItem>
                            </DataList>
                        </Box>
                    </HStack>
                    <DataList variant="stacked">
                        <DataItem dataKey="Address">{serviceProvider.address}</DataItem>
                    </DataList>

                    {serviceProvider.description ? (
                        <Box w="full">
                            <InlineBanner status="info" description={serviceProvider.description} />
                        </Box>
                    ) : null}

                    <FormTextarea
                        textareaProps={{ rows: 1 }}
                        control={control}
                        label="Comments"
                        name="reason"
                        rules={{
                            maxLength: 3000,
                            required: isCommentsRequired ? 'Required' : undefined,
                        }}
                    />

                    <Flex mt="4" justifyContent="flex-end" w="full">
                        <ButtonGroup>
                            <FormSaveButton
                                isDisabled={isManualSelection}
                                variant="ghost"
                                onClick={() => onSkip(serviceProvider)}
                            >
                                Skip
                            </FormSaveButton>
                            <FormSaveButton
                                isDisabled={isManualSelection}
                                variant="outline"
                                onClick={() => onNoAnswer(serviceProvider)}
                            >
                                No Answer
                            </FormSaveButton>
                            <FormSaveButton
                                isDisabled={isManualSelection}
                                variant="outline"
                                onClick={() => onDeclined(serviceProvider)}
                            >
                                Declined
                            </FormSaveButton>
                        </ButtonGroup>
                    </Flex>
                </VStack>
            </Box>
        </Box>
    );
}
